import { ArrowBack, ClosedCaption, KeyboardArrowDown, MenuOutlined, Mic, PlayCircleFilled, VolumeOff as VolumeOffIcon, VolumeUp as VolumeUpIcon, Add } from '@mui/icons-material';
import { Alert, Button, FormControlLabel, Slider, Snackbar, Switch } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Button as AntdButton, Col, Dropdown, Row } from "antd";
import Hls from 'hls.js';
import AnswerPopup from "components/AnswerPopup";
import PDFPopup from "components/PDFPopup";
import AssignableNotificationAnswer from "components/AssignableNotificationAnswer";
import ResourseAssignmentAiModal from "components/AssignmentAiGenerate/ResourseAssignmentAiModal.tsx";
import Instructions from "modules/instructions/teacher/Instructions";
import Loading from "components/Loading";
import BubbleNotes from "components/Notes";
import StoryAIPopup from "components/StoryAIPopup";
import CreateStoryModal from "components/StoryWithAi/CreateStoryModal";
import StoryViewModal from "components/StoryWithAi/StoryViewModal";
import { useFirebase } from "containers/FirebaseContext";
import PodcastTooling from "features/PodcastToolingNew";
import { filter, find, get } from "lodash";
import ShowBookPreviewExtensionActivity from "modules/extraResource/teacher/showBookPreviewExtensionActivity";
import SlideWidget from "modules/slideWidgetModule/slideWidget";
import moment from 'moment';
import queryString from "query-string";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAllBook } from "store/books/selectors";
import { useNotesByBook } from "store/notes/bubbleSelector";
import { useResources, useVideos } from "store/resources/selectors";
import { openSlideWidgetAction } from "store/slides/actions";
import { useGetAllSlidesData } from "store/slides/selectors";
import { useOneStoryWithAi } from "store/StoryAiCofig/selectors";
import { useTimmerRunning } from 'store/timmer/selectors';
import styled from "styled-components";
import COLOR from "utils/constants/color";
import { getBookData, getBookDisplayName, getPageData, imageFetchFromPodcast } from 'utils/lib/ebookHelper';
import { useResourceViews } from "utils/methods/firebaseResource";
import { useResourceActions } from "utils/methods/firebaseResourceDisable";
import { makeStyles } from 'utils/styles/mui';
import linesSvg from "../utils/assets/images/lines.svg";
import { useAnswerView, usePDFView, useActivityStandardsView } from "store/main_book_popup/selectors";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useSideDrawer } from 'utils/context/SideDrawerProvider';
import { Close } from '@mui/icons-material';
import styles from './FeaturesModuleStyling.module.css';
import cloudDownloadSvg from "../utils/assets/images/cloud-download.svg";
import angleDownSvg from "../utils/assets/images/angle-down.svg";
//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------

//  -- Features -----------------------

import Vocabilary from "modules/word_bank/teacher/vocab/Vocabilary";
import Phrases from "modules/word_bank/teacher/Phrases/Phrases";

import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import {
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import CognatesHandler from 'modules/word_bank/teacher/cognates';
import ExtensionActivitiesTooling from 'modules/extraResource/teacher';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SuperLessonDiffList from 'modules/superLessonDiffList';
import SentryWrap from 'components/Sentry';
import ActivityStandardsPopup from 'components/ActivityStandardsPopup';
import { useStandards } from 'store/story/selectors';
import { useOrgStandardCodes } from 'store/organizations/selectors';
import { filterStateStandardByEnabledStates } from 'utils/lib/standardHelper';
import PodcastAddAssignment from './PodcastAddAssignment';


const BTN_KEY = ["add_notes", "add_question", "activity", "description"];

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Container = styled.div`
  max-width: 1600px;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 16px 0px 0px;
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    // flex-direction: row;
    padding: 0px 32px;
  }
  @media only screen and (min-width: 800px) and (max-width: 1200px) {
    padding: 0 14px;
  }
`;

const ImageContainer = styled.div`
  height: auto;
  flex: 1;
`;

const ToolsContainer = styled.div`
  height: 100%;
  margin-top: 48px;
  width: 100%;

  @media (min-width: 800px) {
    margin-top: 0px;
    width: 340px;
  }
`;

const Video = styled.video`
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  height: auto;
  outline: none;
  width: 100%;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-top: 2%;
  position: relative;
  width: 100%;
`;
const VideoContainer = styled.div`
  width: 100%;
  border-bottom: 10px solid rgb(130, 222, 228);
  margin-bottom: 0px;
  border-bottom-width: ${(p) => (p.bottomWidth ? p.bottomWidth : "10px")};
  margin-right: 20px;
  position: relative;
  height:initial;
  @media (max-width: 991px) {
    height:${(p) => (p.openStoryWithAiView ? "70vh" : "initial")};
  }
  @media Screen and (min-width:992px) and  (max-width: 1366px) {
    height:${(p) => (p.openStoryWithAiView ? "54vh" : "initial")};
  }
`;
const ToolingContainer = styled.div`
  width: 100%;
  height: 100%;
  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
  width: ${props => props.isDrawerOpen ? '90%' : '100%'};
  border-bottom: 10px solid rgb(130, 222, 228);
  margin-bottom: 0px;
  border-bottom-width: ${(p) => (p.bottomWidth ? p.bottomWidth : "10px")};
  // margin-left: 20px;
  overflow: visible;
  @media (max-width: 1200px) {
    margin-left: 0px;
    margin-top: 0px;
  }
`;
const VideoTitleSection = styled.div`
  background-color: ${COLOR.indigo300};
  min-height: 50px;
  flex-direction: row;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0px 10px;
  align-items: center;
  position: relative;
  z-index: 1;
`;
const VideoTitle = styled.div`
  color: ${COLOR.white};
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const AddButton = styled.div`
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  background-color: ${COLOR.indigo300};
  color: ${COLOR.white};
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const NotesIconImg = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
`;
const QuestionIconImg = styled.img`
  height: 28px;
  width: 28px;
  object-fit: contain;
`;
const ToolingSubsection = styled.div`
  border-bottom-width: 0px;
  width: 100%;
  padding: 10px;
  height:100%;
  background-color: #e0e0e0;
  //  overflow-y: auto;
  //  height:500px;
`;
const ActivityButton = muiStyled(AddButton)`
  font-size: 12px;
  justify-content: center;
  align-items: center;
  width: 48%;
  min-height: 30px;
  cursor: pointer;
  display:flex;
  flex-direction:row;
`;

const ActivtyButtonConatiner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const ToolsWrapper = styled.div`
  width: 100%;
  // height: 100%;
  margin-top: 10px;
  background-color:#e0e0e0;
   overflow-y: auto;
   max-height: 450px;

   @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    max-height: 300px;
   }
     @media only screen and (min-width: 1500px) and (max-width: 1550px) {
    max-height: 385px !important;
   } 
    @media only screen and (min-width: 1300px) and (max-width: 1400px) {
    // max-height: 330px!important;
   } 
`;

const ButtonClear = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.white};
    cursor: pointer;
    height: 18px;
    outline: none;
    padding: 0px;
    transition: all 300ms ease;

    &:hover {
        color: ${COLOR.black};
    }
`;


const ButtonLink = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black200};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 2px 0px;
    text-transform: uppercase;
`;

const ShowStandardButton = styled.button`
    background-color: #020A52;
    border: 1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1025px) {
        margin-top: 5px;
    }
`;

const ShowStandardButtonInner = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 1px solid #fff;
    padding-left: 6px;
    padding-right: 6px;
`;

const SubtitleToggleButton = muiStyled(AntdButton)`
    position: absolute !important;
    right: 92px;
    bottom: 31px;
    background-color: transparent !important;
    color: white !important;
    z-index: 1;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
`;
const InstButton = muiStyled(Button)`
   border-radius: 8px 8px 0 0 !important;
   box-shadow: none !important;
   font-size: 10px;
   margin-right:1px !important;
`;

const ResourceText = styled.span`
  @media screen and (max-width:746px){
    display:none;
  }
`;
const MobileBar = styled.div`
`;
const MobileMenu = styled.div`
`;

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: "5px",
  },
  selectedOptions: {
    color: "#1890ff !important",
  },



  backText: {
    lineHeight: 1.5,
    color: "#1890ff",
    fontWeight: "bold",
  },
});
const presntationButtonStyle = {
  color: "#575757",
  fontSize: "12px",
  fontWeight: "600",
  display: "block",
  padding: "0px",
  textTransform: "capitalize"
}

//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook
//
//  -- Description
//  Ebook display component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const getTrack = async (url) => {
  const fetchVtt = async () => {
    try {
      const cacheBuster = `?v=${Date.now()}`; 
      const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}${cacheBuster}`, {
        cache: "reload"
      });
      return await response.text();
    } catch (error) {
      console.error('Failed to load subtitles:', error);
      return '';
    }
  };
  return fetchVtt();
};
const useTrackVtt = (data) => {
  const [subtitleUrl, setSubtitleUrl] = useState('');
  const [subtitleUrlEng, setSubtitleUrlEng] = useState('');
  const [vttText, setVttText] = useState('');
  const [vttTextEng, setVttTextEng] = useState('');

  useEffect(() => {
    let url, urlEng;

    const fetchVtt = async (srtUrl) => {
      try {
        let text = await await getTrack(srtUrl);
        if (srtUrl.includes('.srt') || !text.includes('WEBVTT')) {
          text = 'WEBVTT\n\n' + text
            .replace(/\r/g, '')
            .replace(/(\d\d:\d\d:\d\d),(\d\d\d)/g, '$1.$2');
        }
        return text;
      } catch (error) {
        Sentry.captureException(`541 Error in fetchVtt: ${error}`);
        console.error('Failed to load subtitles:', error);
        return '';
      }
    };

    const loadSubtitles = async () => {
      if (data?.srt) {
        const vtt = await fetchVtt(data.srt);
        setVttText(vtt);
        if (vtt) {
          const blob = new Blob([vtt], { type: 'text/vtt' });
          url = URL.createObjectURL(blob);
          setSubtitleUrl(url);
        } else {
          setSubtitleUrl(null);
        }
      } else {
        setVttText('');
        setSubtitleUrl(null);
      }

      if (data?.srt_en) {
        const vttEng = await fetchVtt(data.srt_en);
        setVttTextEng(vttEng);
        if (vttEng) {
          const blob = new Blob([vttEng], { type: 'text/vtt' });
          urlEng = URL.createObjectURL(blob);
          setSubtitleUrlEng(urlEng);
        } else {
          setSubtitleUrlEng(null);
        }
      } else {
        setVttTextEng('');
        setSubtitleUrlEng(null);
      }
    };

    loadSubtitles();

    return () => {
      if (url) URL.revokeObjectURL(url);
      if (urlEng) URL.revokeObjectURL(urlEng);
    };
  }, [data]);

  return { subtitleUrl, vttText, vttTextEng, subtitleUrlEng };
};
const languages = [
  { code: "none", label: "None" },
  { code: "es", label: "ES" },
  { code: "en", label: "EN" }
];


const VideoPlayer = ({ data, getPoster, showCopyRight, vttTrack, listenActions, role, activeActivity, activeQuiz, setAlert, subtitleTracks, openStoryWithAiView, setVideoConfig }) => {
  const [subtitlesEnabled, setSubtitlesEnabled] = useState(true);
  const [volume, setVolume] = useState(50);
  const [hover, setHover] = useState(true);
  const [playCount, setPlayCount] = useState(0);
  const [controlsEnabled, setControlsEnabled] = useState(true);
  const [mute, setMute] = useState(false);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [lastVolume, setLastVolume] = useState(50);
  const videoRef = useRef(null);
  const [selectedLang, setSelectedLang] = useState("es");
  
  const dataUrl = useMemo(() => data?.src, [data?.src]);
  const isHls = useMemo(() => typeof dataUrl === 'string' && dataUrl.includes('.m3u8'), [dataUrl]);
  const hlsPoster = useMemo(() => {
    if(isHls){
      const videoId = dataUrl.split('/')[3];
      if(videoId){
        return `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg`;
      }
    }
    return null;
  }, [dataUrl, isHls]);

  const handleVolumeChange = (val) => {
    if (val === 0) {
      setMute(true);
    } else {
      setMute(false);
    }
    setVolume(val);
    const video = document.querySelector(".oneWayVideoContainer");
    if (video) {
      video.volume = val / 100;
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !isHls) return;

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({ lowLatencyMode: true });
      hls.loadSource(dataUrl);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('HLS.js error:', data);
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = dataUrl;
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [dataUrl, isHls]);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement && role === 'student') {
      if (!controlsEnabled) {
        videoElement.pause();
      } 
      const handlePlay = (e) => {
        if (!controlsEnabled || !listenActions?.play) {
          e.preventDefault();
          e.stopPropagation();
          videoElement.pause();
          setAlert({ open: true, message: "Teacher has blocked students from starting the video." });
        }
      };
      // const handlePause = (e) => {
      //   if (!controlsEnabled) return; 
      //   if (!listenActions?.play) {
      //     e.preventDefault();
      //     e.stopPropagation();
      //     videoElement.play();
      //     setAlert({ open: true, message: "Teacher Block students from stopping videos." })
      //   }
      // };
      videoElement.addEventListener('play', handlePlay);
      // videoElement.addEventListener('pause', handlePause);
      return () => {
        videoElement.removeEventListener('play', handlePlay);
        // videoElement.removeEventListener('pause', handlePause);
      };
    }
  }, [listenActions?.play, controlsEnabled, role]);

  const handleVideoLoaded = () => {
  const video = videoRef.current;
  if (video) {
    const { width, height } = video.getBoundingClientRect();
    setVideoConfig({ width, height, clientHeight:height });
  }
};

  const toggleSubtitles = () => {
    setSubtitlesEnabled(!subtitlesEnabled);
  };

  // const handleVideoEnd = () => {
  //   if ((activeQuiz?.play_video || activeActivity?.play_video)) {
  //     setPlayCount(prevCount => {
  //       const newCount = prevCount + 1;
  //       if (role === 'student' && newCount >= (activeQuiz?.play_video || activeActivity?.play_video)) {
  //         setControlsEnabled(false);
  //       }

  //       return newCount;
  //     });
  //   }
  // };
  const selected_lang = languages.find(l => l.code === selectedLang)?.label
  const track_enabled = (role === "student" && vttTrack && subtitlesEnabled && listenActions?.caption)||((role === "teacher" || role === "admin") && vttTrack && subtitlesEnabled) 
  const has_multi = typeof subtitleTracks=="object" && subtitleTracks && Object.keys(subtitleTracks).length;
  const selected_track = has_multi?subtitleTracks[selectedLang]:vttTrack;

  const subtitleMenuItems = languages.map(({ code, label }) => ({
    key: code,
    label: label,
    onClick: () => {
      if(code === "none"){
        setSelectedLang("none")
        setSubtitlesEnabled(false)
      }else{
        setSelectedLang(code)
        setSubtitlesEnabled(true)
      }
    }
  }));

  return (
    <>
    <VideoContainer
      openStoryWithAiView={openStoryWithAiView}
      className="video-container"
      
      onMouseLeave={() => setHover(false)}
    >
      <div onMouseOver={() => setHover(true)} className="videoWrapper">
        {((role === 'student' && listenActions?.caption) || (role === "teacher" || role === "admin")) && has_multi && (
          <div className='csESMenu'>
            {vttTrack && hover && (
               <Dropdown
               menu={{ items: subtitleMenuItems }}
               trigger={["click"]}
               placement="topRight"
             >
               <SubtitleToggleButton
                className="subtitle-toggle-button"
                onClick={e=>e.preventDefault()}
                onMouseEnter={() => setHover(true)}
              >
                {subtitlesEnabled
                  ? <ClosedCaption color="#fff" />
                  : <ClosedCaption style={{ color: "rgb(252 239 239 / 26%)" }} color="rgb(252 239 239 / 26%)" />
                } {selected_lang!=='none'&&selected_lang!=='None'&&selected_lang?`(${selected_lang})`:''}
              </SubtitleToggleButton>
               </Dropdown>
            )}
          </div>
        )}
        <video
          ref={videoRef}
          className="oneWayVideoContainer videoBackground"
          // autoPlay={role === 'student' ? true : false}
          // loop={role === 'student' ? true : false}
          onContextMenu={(e) => {
            e.preventDefault();
            showCopyRight();
          }}
          onLoadedData={handleVideoLoaded}
          // onEnded={handleVideoEnd}
          controls
          poster={getPoster() || hlsPoster}
          controlsList="nodownload"
          width="100%"
          preload="metadata"
          onMouseEnter={() => setHover(true)}
          onTouchStart={() => {
            setHover(true)
            setTimeout(() => {
              setHover(false);
            }, 3000)
          }}
          onMouseLeave={() => setHover(false)}
        >
          {!isHls && <source src={data?.src} type="video/mp4" />}
          {track_enabled && Boolean(selected_track) && <track
            kind="subtitles"
            src={selected_track}
            srcLang="en"
            label="English"
            default
          />}
        </video>
        {hover && (
          <div
            style={{ background: !showVolumeSlider && "none" }}
            onMouseEnter={() => {setShowVolumeSlider(true); setHover(true)}}
            onTouchStart={() => {
              setShowVolumeSlider(true);
              setHover(true);
              // setTimeout(()=>{
              //   setShowVolumeSlider(false);
              // },5000)
            }}
            onMouseLeave={() => {setShowVolumeSlider(false); setHover(false)}}
            className="volumeSlider volumeControlBtn"
          >
            {mute ? (
              <VolumeOffIcon
                style={{ color: "white" }}
                onClick={() => {
                  const newVolume = lastVolume;
                  const video = document.querySelector(".oneWayVideoContainer");
                  if (video) {
                    video.volume = newVolume / 100;
                  }
                  setVolume(newVolume);
                  setMute((prev) => !prev);
                }}
              />
            ) : (
              <VolumeUpIcon
                style={{ color: "white" }}
                onClick={() => {
                  setLastVolume(volume);
                  const newVolume = 0;
                  const video = document.querySelector(".oneWayVideoContainer");
                  if (video) {
                    video.volume = newVolume / 100;
                  }
                  setVolume(newVolume);
                  setMute((prev) => !prev);
                }}
              />
            )}
            {showVolumeSlider && (
              <Slider
                defaultValue={50}
                value={volume}
                onChange={(e, val) => handleVolumeChange(val)}
                aria-labelledby="continuous-slider"
                min={0}
                max={100}
                step={1}
                valueLabelDisplay="auto"
                style={{ color: "#1976d2", width: "150px", marginLeft: "12px" }}
              />
            )}
          </div>
        )}
      </div>
    </VideoContainer>
    </>
  );
};
const PodcastLayout = ({
  data,
  id,
  quiz,
  activity,
  loading,
  tipsBook,
  quizzes,
  classUsers,
  classQuizzes,
  classActivities,
  submissions,
  loadingContent,
  link,
  currentUser,
  currentClass,
  activities,
  notes,
  interactions,
  showAnswerFlag,
  setShowAnswerFlag
}) => {
  const showAlert = useAlert();
  const [checkInstructionDataForStudent, setCheckInstructionDataForStudent] = useState(false); 
  const [instModal, setInstModal] = useState(false);
  const [vocModal, setVocModal] = useState(false);
  const [phrasesModal, setPhrasesModal] = useState(false);
  const [cogModal,setCogModal] = useState(false);
  const pageNotes = useNotesByBook();
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { pdfView, invokePDFView, revokePDFView } = usePDFView();
  const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer } = useSideDrawer();
  const search = queryString.parse(location.search);
  const [value, setValue] = React.useState(0);
  const [activeBtn, setActiveBtn] = React.useState(BTN_KEY[2]);
  const [activeBtnForDescription, setActiveBtnForDescription] = useState(false);
  const booksAllList = useAllBook()
  const timmerRef = useRef(null)
  const timeIntRef = useRef(0)
  const dispatch = useDispatch()
  const clearPreviewRef = useRef(null)
  const imageRef = useRef();
  const [timeInt, setTimeInt] = useState(0)
  const [timmerRunning, setTimmerRunning, clearTimmerRunning] = useTimmerRunning()
  const submitRef = useRef(null)
  const videos = useVideos()
  const isTeacher = get(currentUser, "role") === "teacher"
  const isStudent = get(currentUser, "role") === "student"
  const isAdmin = currentUser && currentUser?.role === "admin";
  const resources = useResources()
  const isCanvasUser  = !!get(currentUser,"canvas_id")
  // Story AI
  const getStoryWithAi = useOneStoryWithAi();
  const [hasStoryWithAi, setHasStoryWithAi] = useState({});
  
  const [openStoryWithAi, setOpenStoryWithAi] = useState(false);
  const [openStoryWithAiView, setOpenStoryWithAiView] = useState(false);

  const [handleStoryId, setHandleStoryId] = useState('');
  const [handleStoryStream, setHandleStoryStream] = useState('');
  const [handleStoryStreamTitle, setHandleStoryStreamTitle] = useState('');

  const [showStoryModal, setShowStoryModal] = useState(false);
  const [viewLessonType, setViewLessonType] = useState("")

  const { subtitleUrl , vttText , vttTextEng ,subtitleUrlEng } = useTrackVtt(data)
  const { createResourceViews } = useResourceViews()
  const { createResourceActions } = useResourceActions()
  const { firestore } = useFirebase()
  const [alert, setAlert] = useState({
    open: false,
    message: ""
  })
  const bookData = getBookData(activities, quizzes, null, notes, null, interactions, classActivities, classQuizzes, id,currentClass.id,false,currentUser.id)
  const pageData = getPageData(bookData, id, quiz, activity)
  const activeActivity = pageData.activeActivity;
  const activeQuiz = pageData.activeQuiz;
  const enabledStateCodes = useOrgStandardCodes();
   
  const hasActivitiesWithStandards = useMemo(() => {
    const pageActivities = filter(bookData.activities, (activity) => {
      const activityPage = get(activity, 'page') || get(activity, 'data.page');
      return String(activityPage) === String(id);
    });
    
    const pageClassActivities = filter(bookData.classActivities || [], (classActivity) => {
      const activityPage = get(classActivity, 'data.page');
      return String(activityPage) === String(id);
    });
    
    const pageQuizzes = filter(bookData.quizzes || [], (quiz) => {
      const quizPage = get(quiz, 'page') || get(quiz, 'data.page');
      return String(quizPage) === String(id);
    });
    
    const pageClassQuizzes = filter(bookData.classQuizzes || [], (classQuiz) => {
      const quizPage = get(classQuiz, 'data.page');
      return String(quizPage) === String(id);
    });
    
    const allActivities = [...pageActivities, ...pageClassActivities, ...pageQuizzes, ...pageClassQuizzes];
    const uniqueActivities = [];
    const seenIds = new Set();
    
    allActivities.forEach(activity => {
      const dataId = get(activity, 'data.id');
      const activityId = get(activity, 'activityId');
      const wrapperId = get(activity, 'id');
      const finalId = dataId || activityId || wrapperId;
      
      if (finalId && !seenIds.has(finalId)) {
        seenIds.add(finalId);
        uniqueActivities.push(activity);
      }
    });
    
    const activitiesWithStandards = uniqueActivities.filter(activity => {
      const questionsDirect = get(activity, 'questions', []);
      const questionsNested = get(activity, 'data.questions', []);
      const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
      if (!Array.isArray(questions) || questions.length === 0) return false;
      
      return questions.some(q => {
        if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
        const filteredStateStandards = filterStateStandardByEnabledStates(q.state_standard, enabledStateCodes);
        return filteredStateStandards.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
      });
    });
    
    return activitiesWithStandards.length > 0;
  }, [bookData, id, enabledStateCodes]);

  const allActivitiesForStandards = useMemo(() => {
    const pageActivities = filter(bookData.activities, (activity) => {
      const activityPage = get(activity, 'page') || get(activity, 'data.page');
      return String(activityPage) === String(id);
    });
    
    const pageClassActivities = filter(bookData.classActivities || [], (classActivity) => {
      const activityPage = get(classActivity, 'data.page');
      return String(activityPage) === String(id);
    });
    
    const pageQuizzes = filter(bookData.quizzes || [], (quiz) => {
      const quizPage = get(quiz, 'page') || get(quiz, 'data.page');
      return String(quizPage) === String(id);
    });
    
    const pageClassQuizzes = filter(bookData.classQuizzes || [], (classQuiz) => {
      const quizPage = get(classQuiz, 'data.page');
      return String(quizPage) === String(id);
    });
    
    const allActivities = [...pageActivities, ...pageClassActivities, ...pageQuizzes, ...pageClassQuizzes];
    const uniqueActivities = [];
    const seenIds = new Set();
    
    allActivities.forEach(activity => {
      const dataId = get(activity, 'data.id');
      const activityId = get(activity, 'activityId');
      const wrapperId = get(activity, 'id');
      const finalId = dataId || activityId || wrapperId;
      
      if (finalId && !seenIds.has(finalId)) {
        seenIds.add(finalId);
        uniqueActivities.push(activity);
      }
    });
    
    const filtered = uniqueActivities.filter(activity => {
      const questionsDirect = get(activity, 'questions', []);
      const questionsNested = get(activity, 'data.questions', []);
      const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
      if (!Array.isArray(questions) || questions.length === 0) return false;
      
      return questions.some(q => {
        if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
        return q.state_standard.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
      });
    });
    
    return filtered;
  }, [bookData, id]);
  const videoInfo = find(resources?.flatMap(k=>k.videos), ["id", search.id]);
  const parentInfo = resources.find(resource => resource.videos.some(video => video.id === search.id));
  const [studentViewFlag, setStudentViewFlag] = React.useState(false);
  const [resourceView, setResourceView] = useState({})
  const [hasViewed, setHasViewed] = useState(false);
  const [actionShowCaptions, setActionShowCaptions] = useState(true);
  const [actionShowPlay, setActionShowPlay] = useState(true);
  const [listenActions, setListenActions] = useState({});
  const [assignmentAiModal, setassignmentAiModal] = useState(false);
  const [videoConfig,setVideoConfig] = useState({width: 0, height: 0});
  const [isOpen, setIsOpen] = useState(false);
  const getVideos = find(videos, ['id', id])
  const existShowAnswer = get(getVideos, "meta_resources.answers", []).length > 0;
  const pdf_page = useMemo(() => {
    const pagesPDF = get(getVideos, "meta_resources.pagesPDF", []);
    return pagesPDF.find(pdf => pdf.pageId === id) || null;
  }, [getVideos, id]);
  const { invokeAnswerView, revokeAnswerView } = useAnswerView();
  const { activityStandardsView, invokeActivityStandardsView, revokeActivityStandardsView } = useActivityStandardsView();
  const standards = useStandards();
  const {checkPopUpAtOnce, updatePopUpAtOnce, openPopUpAtOnce} = usePopUpAtOnce();
  

  const [shareWithMe, setShareWithMe] = useState(false);
  const [shareByMe, setShareByMe] = useState(false);
  const [shareDropdownOpen, setShareDropdownOpen] = useState(false);
  const [videoControlsDropdownOpen, setVideoControlsDropdownOpen] = useState(false);

  const generateQuestionRef = useRef()
  useEffect(() => {
    const unsubscribe = listenToResourceActions(get(videoInfo, 'id', ''), get(currentClass, 'id', ''));
    return () => {
      unsubscribe();
    };
  }, [firestore, currentClass, videoInfo])
    const [anchorEl, setAnchorEl] = React.useState(null);

  const getAllSlideData = useGetAllSlidesData();
  const video_slide = useMemo(() => getAllSlideData?.find((x) => x.book_id == id), [id, getAllSlideData])
  const has_all_page = useMemo(() => filter(video_slide?.pages, (item) => item?.src != ""), [video_slide]);
  const slide_widget = useMemo(() => {
    const has_all_page = filter(video_slide?.pages, (item) => item?.src != "");

    if (!has_all_page || has_all_page?.length == 0 || currentUser?.role == "student") {
      return null;
    } else {
      return (<SlideWidget bookId={id} pageId={id} onClick={()=>setAnchorEl(null)} btnStyle={presntationButtonStyle} />)
    }
  }, [video_slide, id, currentUser]); 
  const getSlideData = useGetAllSlidesData();
  const filterDatas = getSlideData?.find((x) => x.book_id == id && x.page_id == id)

  const handlerOpen = async (value) => {
    const widgetData = {
      open: true,
      pageId: id,
      bookId: id,
      data: filterDatas
    };
    await dispatch(openSlideWidgetAction(widgetData));
  };

  useEffect(() => {
    const filterByPage = filter(
      getStoryWithAi,
      (item) => item?.page === id
    ) || {};
    setHasStoryWithAi(filterByPage);
  }, [id, getStoryWithAi]);

  const handleOpenTool = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseTool = () => {
    setAnchorEl(null);
  };
  const listenToResourceActions = (videoId, classId) => {
    if (!videoId || !classId) {
      return () => { };
    }
    const collectionRef = collection(firestore, "resource_video_actions");
    const q = query(collectionRef, where("classId", "==", classId), where("videoId", "==", videoId));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      let viewData = null;
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          viewData = { id: doc.id, ...doc.data() };
        });
      }
      if (viewData) {
        setActionShowCaptions(viewData?.action?.caption);
        setActionShowPlay(viewData?.action?.play)
        setListenActions(viewData?.action);
      } else {
        setListenActions({
          caption: true,
          play: true
        });
      }
    }, (error) => {
      console.error("Error listening to session changes:", error);
    });

    return unsubscribe;
  };

  useEffect(() => {
    const unsubscribe = listenToShareWidgetData(get(videoInfo, 'id', ''));
    return () => {
      unsubscribe();
    };
  }, [])

  const listenToShareWidgetData = (videoId) => {
    if (!videoId) {
      return () => { };
    }

    const collectionRef = collection(firestore, "most_viewed_video");
    const q = query(collectionRef, where("id", "==", videoId));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      let viewData = null;
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          viewData = { id: doc.id, ...doc.data() };
        });
      }
      setResourceView(viewData);
    }, (error) => {
      console.error("Error listening to session changes:", error);
    });

    return unsubscribe;
  };


  useEffect(() => {
    if (resourceView && resourceView.id && !hasViewed) {
      createViewedVideo();
      setHasViewed(true);
    } else if (!resourceView) {
      createViewedVideo();
      setHasViewed(true);
    }
  }, [resourceView, hasViewed]);

  const createViewedVideo = () => {
    const CreateNewView = {
      // ...resourceView,
      type: "resource",
      id: get(videoInfo, 'id', ''),
      viewed_video: (resourceView?.viewed_video || 0) + 1
    };
    createResourceViews(CreateNewView)
  };
  const handleForDistrictAdmin = () => {
      if (currentUser.role === 'admin') {
        setAlert({ open: true, message: 'Please login as teacher!' });
        return true;
      }
      return false;
  };

  const showCopyRight = () => {
    setAlert({ open: true, message: "Content is protected!" })
  };

  const handleClose = () => {
    setAlert({ open: false, message: "" })
  };

  const backToResources = () => {
    navigate(`/resources?link=${parentInfo?.key ?? null}`);
  };
  useEffect(() => {
    if (currentUser?.role != 'student') return;
    try {
      let actAct = find(classActivities, x => (get(x, "data.id") === activity))
      let actqz = find(classQuizzes, x => (get(x, "data.id") === quiz))
      let Actdata = find(submissions, ['assignmentId', get(actAct, "activityId")])
      let qzdata = find(submissions, ['assignmentId', get(actqz, "quizId")])
      let _timmer = 0
      let _durration = 0;
      if (activity && typeof activity === "string" && activity != "null" && activity != "undefined" && actAct) {
        _durration = actAct.timeDuration
        if (Actdata) {
          if (!Actdata.complete) {
            _timmer = Actdata.timmer
          }
          handleTimmer(_durration, _timmer)
        } else {
          handleTimmer(_durration, _timmer)
        }

      } else if (quiz && typeof quiz === "string" && quiz != "null" && quiz != "undefined" && actqz) {
        _durration = actqz.timeDuration
        if (qzdata) {
          if (!qzdata.complete) {
            _timmer = qzdata.timmer
            handleTimmer(_durration, _timmer)
          }
        } else {
          handleTimmer(_durration, _timmer)
        }
      }

    } catch (error) {
      Sentry.captureException(`542 Error in handleTimmer: ${error}`);
      console.log(error, "errr")
    }

  }, [activity, quiz, classActivities, classQuizzes])
  const handleTimmer = (timeDuration, timer) => {
    try {
      if (timeDuration && !isNaN(parseInt(timeDuration)) && parseInt(timeDuration) > 0) {
        let _timer = parseInt(timer) > 0 ? parseInt(timer) : parseInt(timeDuration) * 60
        if (timmerRef.current) { onFinish() };
        timeIntRef.current = _timer;
        setTimmerRunning()
        timmerRef.current = setInterval(() => {
          if (timeIntRef.current > 0) {
            timeIntRef.current = timeIntRef.current - 1
            let timePrint = moment.utc(timeIntRef.current * 1000).format('HH:mm:ss');
            setTimeInt(timePrint)
          } else {
            if (typeof submitRef.current == "function") {
              submitRef.current(true, null, false, null, true)
              submitRef.current = null
              onFinish()
            }
          }
        }, 1000)
      }
    } catch (error) {
      Sentry.captureException(`543 Error in handleTimmer: ${error}`);
      console.log(error, "error in effect");
    }
    return () => {
      onFinish()
    }
  }
  const onFinish = () => {
    clearInterval(timmerRef.current)
    setTimeInt(0)
    timeIntRef.current = 0
    timmerRef.current = null
    clearTimmerRunning()
  }
  const setSubmitRef = (ref) => {
    submitRef.current = ref
  }
  const getPoster = () => {
    return get(find(resources, ['key', search.link]), "poster", '')
  }
  const timmerAlert = () => {
    setAlert({ open: true, message: "This functionality is blocked for time-based activities." })
  }

  const onHideShowVideos = (hideFrom) => {
    if (hideFrom === 'caption') {
      setActionShowCaptions(!actionShowCaptions)
      const ResourceData = {
        classId: get(currentClass, 'id', ''),
        videoId: id,
        action: {
          caption: !actionShowCaptions,
          play: actionShowPlay
        }
      }
      createResourceActions(ResourceData)
    } else {
      setActionShowPlay(!actionShowPlay)
      const ResourceData = {
        classId: get(currentClass, 'id', ''),
        videoId: id,
        action: {
          caption: actionShowCaptions,
          play: !actionShowPlay
        }
      }
      createResourceActions(ResourceData)
    }
  }

  const navigateToTeacherDashboard = (to) => {
    switch (to) {
      case "manage":
        navigate("/admin/class?view=manage")
        break;
      case "gradebook":
        navigate("/admin/class?view=gradebook")
        break;
      case "classdata":
        navigate("/admin/class?view=classdata")
        break;
      default:
        navigate("/admin/class?view=home")
        break;
    }
  }
  const navigateToStudentDashboard = (to) => {
    switch (to) {
      case "calendar":
        navigate("/student/class?view=assessments")
        break;
      case "studentData":
        navigate("/student/class?view=studentData")
        break;
      default:
        navigate("/student/class?view=home")
        break;
    }
  }
  const toolbarNav = () => {
    const toolbarMenuItems = [
      ...(isStudent ? [
        {
          key: 'calendar',
          label: (
            <ButtonClear onClick={() => navigateToStudentDashboard("calendar")}>
              calendar
            </ButtonClear>
          ),
          style: { 
            borderBottom: "1px dotted white",
            backgroundColor: "rgb(121 120 199)"
          }
        },
        {
          key: 'studentData',
          label: (
            <ButtonClear onClick={() => navigateToStudentDashboard("studentData")}>
              Student Data
            </ButtonClear>
          ),
          style: { backgroundColor: "rgb(121 120 199)" }
        }
      ] : []),
      ...(isTeacher ? [
        {
          key: 'home',
          label: (
            <ButtonClear onClick={() => navigateToTeacherDashboard("home")}>
              Home
            </ButtonClear>
          ),
          style: { backgroundColor: "rgb(121 120 199)" }
        },
        {
          key: 'gradebook',
          label: (
            <ButtonClear onClick={() => navigateToTeacherDashboard("gradebook")}>
              Gradebook
            </ButtonClear>
          ),
          style: { backgroundColor: "rgb(121 120 199)" }
        },
        {
          key: 'classdata',
          label: (
            <ButtonClear onClick={() => navigateToTeacherDashboard("classdata")}>
              Class Data
            </ButtonClear>
          ),
          style: { backgroundColor: "rgb(121 120 199)" }
        }
      ] : [])
    ];

    return { items: toolbarMenuItems };
  };
  const RenderMenuContent = ({ showLargeDrawer }) => {
    const menuItems = [
      ...(currentUser?.role === "teacher" ? [
        {
          key: 'caption',
          label: `${listenActions?.caption ? "Disable" : "Enable"} Caption`,
          style: {
            backgroundColor: `${listenActions?.caption ? "none" : "red"}`,
            color: `${listenActions?.caption ? "none" : "white"}`,
          },
          className: "ulLitItmeList",
          onClick: () => {
            onHideShowVideos("caption");
          }
        },
        ...(isTeacher ? [
          {
            key: 'play',
            label: `${listenActions?.play ? "Disable" : "Enable"} Play Video`,
            style: {
              backgroundColor: `${listenActions?.play ? "none" : "red"}`,
              color: `${listenActions?.play ? "none" : "white"}`,
            },
            className: "ulLitItmeList",
            onClick: () => {
              onHideShowVideos("play");
            }
          },
          {
            key: 'instruction',
            label: 'Instruction',
            className: "ulLitItmeList",
            onClick: () => {
              if(checkPopUpAtOnce()) return;
              updatePopUpAtOnce(true);
              setInstModal(true);
            }
          }
        ] : [])
      ] : []),
      {
        key: 'vocabulary',
        label: 'Vocabulary',
        className: "ulLitItmeList",
        onClick: () => {
          setVocModal(true);
        }
      },
      // {
      //   key: 'phrases',
      //   label: 'Phrases',
      //   className: "ulLitItmeList",
      //   onClick: () => {
      //     if(checkPopUpAtOnce()) return;
      //     updatePopUpAtOnce(true);
      //     setPhrasesModal(true);
      //   }
      // },
      {
        key: 'cognates',
        label: 'Cognates',
        className: "ulLitItmeList",
        onClick: () => {
          setCogModal(true);
        }
      },
      {
        key: 'sharewithme',
        label: 'Shared with me',
        className: "ulLitItmeList",
        onClick: () => {
          if(checkPopUpAtOnce()) return;
          updatePopUpAtOnce(true);
          setShareWithMe(true);
        }
      },
      {
        key: 'sharebyme',
        label: 'Shared by me',
        className: "ulLitItmeList",
        onClick: () => {
          if(checkPopUpAtOnce()) return;
          updatePopUpAtOnce(true);
          setShareByMe(true);
        }
      },
      ...(currentUser?.role === "student" && checkInstructionDataForStudent ? [
        {
          key: 'playInstruction',
          label: 'Play Instruction',
          className: "ulLitItmeList",
          onClick: () => {
            if(checkPopUpAtOnce()) return;
            updatePopUpAtOnce(true);
            setInstModal(true);
          }
        }
      ] : []),
      ...(currentUser?.role === "student" && Array.isArray(hasStoryWithAi) && hasStoryWithAi.length > 0 ? [
        {
          key: 'soyHistorias',
          label: 'Soy Historias',
          className: "ulLitItmeList",
          onClick: () => {
            handleOpenStoryWithAi();
          }
        }
      ] : [])
    ];

    return { items: menuItems };
  };
  const video_title = useMemo(() => {
    return getBookDisplayName(booksAllList, id, true, videos, resources)
  }, [booksAllList, videos, resources, id]);

  const getImageRef = () => {
    return imageRef.current;
  }
  const onGenerateClick = () => {
    setassignmentAiModal(true);
    handleCloseTool();
    if (generateQuestionRef.current && generateQuestionRef.current.generateQuestions) {
      generateQuestionRef.current.generateQuestions()
    }
  }

  const handleOpenStoryWithAi = (type) => {
     if(!type && checkPopUpAtOnce()) return;
    updatePopUpAtOnce(true);
    if (isAdmin) {
        showAlert("Please login as teacher!", "error");
        return;
    }
    if (hasStoryWithAi?.length > 0 && type !== "more_story") {
        setOpenStoryWithAi(true);
        setOpenStoryWithAiView(true);
    } else {
        setShowStoryModal(true);
      }
      handleCloseTool();
  };

  // const Tools = useMemo(() => {
  //   if (currentUser?.role == "student") return null;
  //   return (<>
  //     <Button
  //       onClick={handleOpenTool}
  //       style={{ minWidth: "unset", height: "36px", borderRadius: "0px !important" }}
  //       className="vocabularyBtnDiff"
  //       onMouseEnter={handleOpenTool}
  //     >
  //       Tools
  //     </Button>
  //     <Popover 
  //       id={Boolean(anchorEl) ? 'simple-popover' : undefined} 
  //       open={Boolean(anchorEl)} 
  //       anchorEl={anchorEl} 
  //       onClose={handleCloseTool}
  //       anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  //       transformOrigin={{vertical: 'top',horizontal: 'center' }}
  //       disableScrollLock={true}
  //     >
  //       <Typography sx={{ p: 2 }} className="chngOptList chngOptListData">
  //         <ul>
  //           <li><a onClick={onGenerateClick}>Generate Assignment with AI</a></li>
  //           {Boolean(has_all_page && has_all_page.length > 0) && (
  //             <li>{slide_widget}</li>
  //           )}
  //           <li><a onClick={() => {
  //             setIsOpen(true)
  //             setAnchorEl(null);
  //           }}>Generate Grammar Drills</a></li>
  //         </ul>
  //       </Typography>
  //     </Popover>
  //   </>)
  // }, [currentUser, anchorEl, generateQuestionRef.current])

  const handleMenuClick = (event) => {
    event.preventDefault();
      if (isAdmin) {
        showAlert("Please login as teacher!", "error");
    }
  };
      useEffect(() => {
        function updateStyle() {
          const getRef = getImageRef();
          if (getRef) {
            const { width, height } =
              getRef.getBoundingClientRect();
            setVideoConfig({ clientHeight: height, width, height });
          }
        }

        updateStyle();
        window.addEventListener("resize", updateStyle);

        return () => {
          window.removeEventListener("resize", updateStyle);
        };
      }, [hasStoryWithAi]);

  const onAnswerClick = () => {
    invokeAnswerView(get(getVideos, "meta_resources.answers", []));
  }
  const onPDFClick = () => {
    if(checkPopUpAtOnce()){ 
      return;
    }
    updatePopUpAtOnce(true);
    invokePDFView(pdf_page);
  }
  const isDistrictAdmin = get(currentUser, "role") === "admin";
  const TrackDownloader = ({vttText,id , title , engTrack}) => {

    const formatVttText = (vttText) => {
      return vttText
        .split('\n\n')
        .filter((block) => block.includes('-->'))
        .map((block) => {
          const [time, ...textLines] = block.split('\n');
          let k = textLines.join('\n').includes('-->') ? '\n' : `\n${time}\n`
          // remove all html tag from k 
          let sub_titile = textLines.join('\n').replace(/<[^>]*>/g, '');
          sub_titile = sub_titile.replace(/Generating images\.\.\./g, '').trim();
          return `${k}${sub_titile}\n`;
        })
        .join('\n');
    };
  
    const downloadVttAsPdf = async (lang) => {
      const { default: jsPDF } = await import('jspdf');
      const fileName = title || id || 'subtitles';
      const doc = new jsPDF();
      const formattedText = formatVttText(lang=='en'?engTrack:vttText);
  
      const pageHeight = doc.internal.pageSize.height; // Page height in mm
      const lineHeight = 10; // Approximate line height in mm
      const marginTop = 10; // Margin at the top of the page
      const maxLinesPerPage = Math.floor((pageHeight - marginTop) / lineHeight); // Maximum number of lines per page
  
      const lines = formattedText.split('\n');
      let cursorY = marginTop;
      let lineCounter = 0; // To track the number of lines printed on the current page
  
      lines.forEach((line, index) => {
        if (lineCounter >= maxLinesPerPage) {
          doc.addPage(); // Add new page when the current one is full
          cursorY = marginTop; // Reset cursor to the top of the new page
          lineCounter = 0; // Reset line counter
        }
  
        doc.text(line, 10, cursorY); // Add text to the current page
        cursorY += lineHeight; // Move cursor down by one line
        lineCounter++; // Increment line counter
      });
  
      doc.save(`${fileName}.pdf`);
    };
  
    const menuItems = [
      {
        key: 'es',
        label: 'Spanish',
        onClick: () => downloadVttAsPdf('es')
      },
      {
        key: 'en',
        label: 'English',
        onClick: () => downloadVttAsPdf('en')
      }
    ];
  
    if (!vttText) return null;
    if (engTrack) {
      return (<Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
        
      >
         <Button className='downloadSubtitleBtn' variant="contained" color="primary" onClick={e=>e.preventDefault()} 
           startIcon={<img src={cloudDownloadSvg} alt="" title="" className='downloadCloudeBtn' />} 
           endIcon={<img src={angleDownSvg} alt="" title="" className='downloadSubTitle' />}>Download Subtitles</Button>
      </Dropdown>)
    }
    return  <Button className='downloadSubtitleBtn' variant="contained" color="primary" onClick={downloadVttAsPdf} 
       startIcon={<img src={cloudDownloadSvg} alt="" title="" className='downloadCloudeBtn' />}>Download Subtitles</Button>
  }
  return (
    <SentryWrap>
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          <strong>ALERT:</strong> {alert.message}
        </Alert>
      </Snackbar>
      <Wrapper
        onContextMenu={(e) => {
          e.preventDefault();
          showCopyRight();
        }}>
        <Container>
          <ResourseAssignmentAiModal
            data={{}}
            assignmentAiModal={assignmentAiModal}
            setassignmentAiModal={setassignmentAiModal}
            page={id}
            chapter={id}
            content_type={"resources"}
            ref={generateQuestionRef}
            
          />
          <ImageContainer>
            {loading ? (
              <Loading />
            ) : (
              <>
                
                <Row gutter={[20,20]}>
                  <Col ref={imageRef} xs={{ span: isDrawerOpen ? 0 : 24 }} md={{ span: isDrawerOpen ? 0 : 24 }} lg={{ span: isDrawerOpen ? 0 : 24 }} xl={{ span: isDrawerOpen ? 0 : 16 }} style={{position:'relative'}}>
                      <Row style={{ display: isDrawerOpen ? 'none' : 'flex' }}>
                        <Button
                          onClick={() => {
                            backToResources();
                          }}
                          className='bkToRsourceBtn'
                        >
                          <ArrowBack style={{ fontSize: "14px", marginRight: "4px" }} />
                          Back&nbsp;<ResourceText> to Resources</ResourceText>
                        </Button>
                        <div style={{marginInline: "1.5px"}}>
                        <Instructions pageId={id} bookId={id} instModal={instModal} setInstModal={setInstModal} from={"balcon"}  setCheckInstructionDataForStudent={(value)=>setCheckInstructionDataForStudent(value)}  customClass="resourceMicSection"/>
                          </div>
                          <div className="micBtnHide">
                            {currentUser?.role === 'teacher' ? (
                            <InstButton className={classes.button} size="small" style={{ background: 'rgb(0, 43, 112)' }} onClick={() => setInstModal(true)}>
                              <Mic color="error" style={{ backgroundColor: "#fff", borderRadius: "50%" }} />
                            </InstButton>
                            ) : (
                              <>
                                { checkInstructionDataForStudent && (
                                  <InstButton className={classes.button} size="small" style={{ background: 'rgb(0, 43, 112)' }} onClick={() => setInstModal(true)}>
                                    <PlayCircleFilled color="error" style={{ backgroundColor: "#fff", borderRadius: "50%" }} /> 
                                  </InstButton>
                                  )}
                              </>
                            )}
                          </div>
                          <div className="vocablaryBtn">
                            <Vocabilary from="resource" pageId={id} bookId={id} isVocabulary={true} isCheckingOpen={vocModal} setVocModal={setVocModal} />
                            </div>
                          {/* <div className={currentUser?.role === "student" ? "ml-5px vocablaryBtn" : "vocablaryBtn"}>
                          <Phrases from="resource" pageId={id} bookId={id} isVocabulary={true} isCheckingOpen={phrasesModal} setVocModal={setPhrasesModal} />
                            </div> */}
                            <div className={currentUser?.role === "student" ? "ml-5px vocablaryBtn" : "vocablaryBtn"}>
                            <CognatesHandler from="resource" non_spanish_vocab={false}  pageId={id} bookId={id} isCheckingOpen={cogModal} setVocModal={setCogModal}  />
                            </div>
                          {/* {Tools} */}
                        <MobileBar className="mobileTabs eBookTabLft eBookTabMob hideInMObSection video-section-drawer">
                              <MobileMenu className="mobileTabDropVideo">
                                <Dropdown menu={RenderMenuContent({ showLargeDrawer: true })} trigger={['click']}>
                                  <Button style={{ display: 'flex', alignItems: 'center' }} className="BtnMenuOptions">
                                    <MenuOutlined />
                                  </Button>
                                </Dropdown>
                              </MobileMenu>
                            </MobileBar>

                        {currentUser?.role === 'teacher' && (
                          <>
                            <Dropdown
                              open={videoControlsDropdownOpen}
                              onOpenChange={setVideoControlsDropdownOpen}
                              trigger={['click']}
                              placement="bottomLeft"
                              dropdownRender={() => (
                              <div className={styles.captionDropdownStyle}>
                                <Button style={{
                                    borderRadius: "0px !important",
                                    minWidth: "unset",
                                    height: "36px",
                                    marginLeft: currentUser?.role === 'student' && 0,
                                    backgroundColor: `${ listenActions.hasOwnProperty('caption') ? listenActions?.caption ? '#002b70' : 'red' : "#002b70"}`
                                  }}
                                    onClick={() => {
                                      onHideShowVideos('caption');
                                      setVideoControlsDropdownOpen(false);
                                    }}
                                    className={'videoSectionDisable superLessonButton'}
                                  >{`${listenActions?.caption ? 'disable' : 'enable'} caption`}</Button>
                                  <Button style={{
                                    borderRadius: "0px !important",
                                    minWidth: "unset",
                                    height: "36px",
                                    marginLeft: currentUser?.role === 'student' && 0,
                                  backgroundColor: `${ listenActions.hasOwnProperty('play') ? listenActions?.play ? '#002b70' : 'red' : "#002b70"}`,
                                  }}
                                    onClick={() => {
                                      onHideShowVideos('play');
                                      setVideoControlsDropdownOpen(false);
                                    }}
                                    className={'videoSectionDisable superLessonButton'}
                                  >{`${listenActions?.play ? 'disable' : 'enable'} play video`}</Button>
                              </div>
                              )}
                            >
                              <Button style={{
                              borderRadius: "0px !important",
                              minWidth: "unset",
                              height: "36px",
                              marginLeft: currentUser?.role === 'student' && 0,
                              backgroundColor: '#002b70',
                            //  backgroundColor: `${ listenActions.hasOwnProperty('play') ? listenActions?.play ? '#002b70' : 'red' : "#002b70"}`
                                }}
                                className={'videoSectionDisable superLessonButton'}
                              >
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                  Video
                                  <KeyboardArrowDown style={{ fontSize: 18 }} />
                                </span>
                              </Button>
                            </Dropdown>
                            <Dropdown
                              open={shareDropdownOpen}
                              onOpenChange={setShareDropdownOpen}
                              trigger={['click']}
                              placement="bottomLeft"
                              dropdownRender={() => (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 4,
                                    padding: 4,
                                    background: '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    borderRadius: 2,
                                  }}
                                >
                                  <Button
                                    style={{
                                      borderRadius: "0px !important",
                                      minWidth: "unset",
                                      height: "36px",
                                      marginLeft: currentUser?.role === 'student' && 0,
                                      backgroundColor: '#002b70',
                                    }}
                                    onClick={() => {
                                      setShareWithMe(true);
                                      setShareDropdownOpen(false);
                                    }}
                                    className={'videoSectionDisable superLessonButton'}
                                  >
                                    Shared with me
                                  </Button>
                                  <Button
                                    style={{
                                      borderRadius: "0px !important",
                                      minWidth: "unset",
                                      height: "36px",
                                      marginLeft: currentUser?.role === 'student' && 0,
                                      backgroundColor: '#002b70',
                                    }}
                                    onClick={() => {
                                      setShareByMe(true);
                                      setShareDropdownOpen(false);
                                    }}
                                    className={'videoSectionDisable superLessonButton'}
                                  >
                                    Shared by me
                                  </Button>
                                </div>
                              )}
                            >
                              <Button
                                style={{
                                  borderRadius: "0px !important",
                                  minWidth: "unset",
                                  height: "36px",
                                  marginLeft: currentUser?.role === 'student' && 0,
                                  backgroundColor: '#002b70',
                                }}
                                className={'videoSectionDisable superLessonButton'}
                              >
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                  Shared
                                  <KeyboardArrowDown style={{ fontSize: 18 }} />
                                </span>
                              </Button>
                            </Dropdown>
                            
                          </>
                        )}
                      </Row>
                      <VideoPlayer
                      openStoryWithAiView={openStoryWithAiView}
                      data={data}
                      showCopyRight={showCopyRight}
                      getPoster={getPoster}
                      vttTrack={subtitleUrl}
                      listenActions={listenActions}
                      role={currentUser?.role}
                      activeActivity={activeActivity}
                      activeQuiz={activeQuiz}
                      setAlert={setAlert}
                      subtitleTracks={{
                        es: subtitleUrl,
                        en: subtitleUrlEng
                      }}
                      setVideoConfig={setVideoConfig}
                    />
                     <ShowBookPreviewExtensionActivity getRef={getImageRef} />

                      <AnswerPopup getRef={getImageRef} onClose={() => {
                        setShowAnswerFlag(false)
                      }} />
                      <PDFPopup getRef={getImageRef} onClose={() => {
                        setShowAnswerFlag(false)
                      }} />
                      <ActivityStandardsPopup 
                        getRef={getImageRef} 
                        onClose={() => {
                          revokeActivityStandardsView();
                        }}
                        customSize={videoConfig}
                      />
                      <StoryAIPopup getRef={getImageRef} onClose={() => {}} />
                      {showStoryModal && (
                          <CreateStoryModal
                            data={data}
                            open={showStoryModal}
                            onClose={() => {
                              updatePopUpAtOnce(false);
                              setShowStoryModal(false);
                            }}
                            storyData={hasStoryWithAi}
                            onShowView={(id) => {
                              setHandleStoryId(id);
                              setOpenStoryWithAi(true);
                              setOpenStoryWithAiView(true);
                            }}
                            onShowStreamView={(val) => {
                              setHandleStoryStream(val);
                              setOpenStoryWithAi(true);
                              setOpenStoryWithAiView(true);
                            }}
                            onStoryTitle={(title) => {
                                setHandleStoryStreamTitle(title);
                                setOpenStoryWithAi(true);
                                setOpenStoryWithAiView(true);
                            }}
                            from={'resource'}
                            isCanvasUser={isCanvasUser}
                            page={id}
                            chapter={id}
                            customStyle={{position:'unset'}}
                          />
                      )}
                      <AssignableNotificationAnswer getRef={getImageRef} />

                        {openStoryWithAi &&
                            <StoryViewModal
                                imageConfiguration={videoConfig}
                                open={openStoryWithAiView}
                                setOpenStoryWithAiView={setOpenStoryWithAiView}
                                viewLessonType={viewLessonType}
                                onClose={() => {
                                    updatePopUpAtOnce(false);
                                    setOpenStoryWithAi(false);
                                    setOpenStoryWithAiView(false);
                                }} 
                                onMoreStory={() => {
                                    setOpenStoryWithAi(false);
                                    updatePopUpAtOnce(false);
                                    setOpenStoryWithAiView(false);
                                    handleOpenStoryWithAi('more_story');
                                }}
                                isCanvasUser={isCanvasUser}
                                hasStoryWithAi={hasStoryWithAi}
                                handleStoryId={handleStoryId}
                                setHandleStoryStream={setHandleStoryStream}
                                handleStoryStream={handleStoryStream}
                                setHandleStoryStreamTitle={setHandleStoryStreamTitle}
                                handleStoryStreamTitle={handleStoryStreamTitle}
                            />
                        }
                  </Col>
                  <Col gap={0} className="rghtNoteSection" xs={{ span: isDrawerOpen ? 24 : 24 }} md={{ span: isDrawerOpen ? 24 : 24 }} lg={{ span: isDrawerOpen ? 24 : 24 }} xl={{ span: isDrawerOpen ? 24 : 8 }}>
                    <div className={styles.podcastToolingUpperSection}>
                      {loadingContent ? <Loading /> : 
                        <PodcastAddAssignment 
                          isDrawerOpen={isDrawerOpen}
                          data={data}
                          id={id}
                          quiz={search.quiz}
                          activity={search.activity}
                          section={BTN_KEY.findIndex((k) => k == activeBtn)}
                          tipsBook={tipsBook}
                          quizzes={quizzes}
                          setShowAnswerFlag={setShowAnswerFlag}
                          showAnswerFlag={showAnswerFlag}
                          classUsers={classUsers}
                          classQuizzes={classQuizzes}
                          submissions={submissions}
                          studentViewFlag={studentViewFlag}
                          setStudentViewFlag={setStudentViewFlag}
                          loadingContent={loadingContent}
                          search={search}
                          setSubmitRef={setSubmitRef}
                          timeInt={timeInt}
                          timmer={timeIntRef.current}
                          videoInfo={find(get(find(resources, ['key', search.link]), "videos"), ["id", search.id])}
                          onFinish={onFinish}
                          onPageChage={re => clearPreviewRef.current = re}
                          track={vttText}
                          engTrack={vttTextEng}
                          listenActions={listenActions}
                          title={getBookDisplayName(booksAllList, id, true, videos, resources)}
                          onClose={() => {
                            setActiveBtn(BTN_KEY[2]);
                          }}
                          handleOpenStoryWithAi={handleOpenStoryWithAi}
                          hasStoryWithAi={hasStoryWithAi}
                          onGenerateClick={onGenerateClick}
                          handlerOpenPresentation={handlerOpen}
                          has_all_page={has_all_page}
                        />}
                    </div>
                    
                    <ToolingContainer style={{ maxHeight: 700, height: "100%" }} className={`${isDrawerOpen ? 'setFullMatchMake' : ''}`}>
                      {
                        isDrawerOpen && (
                          <div className="">
                            <Close onClick={closeDrawer}
                              style={{ color: "red", fontWeight: "bolder", fontSize: 35, cursor: 'pointer' }}
                            />
                          </div>

                        )
                      }
                      <VideoTitleSection>
                        <VideoTitle>{video_title}  </VideoTitle>
                        <div className="flex items-center">
                        
                        {
                          currentUser?.role === "student" && (
                            isDrawerOpen ? (
                            <FullscreenExitIcon  sx={{ color: 'white', fontSize: '41px', cursor: 'pointer', marginRight: "5px" }} onClick={toggleDrawer} />
                          ) : (
                            <FullscreenIcon sx={{ color: 'white', fontSize: '41px', cursor: 'pointer', marginRight: "5px" }} onClick={toggleDrawer} />
                          )
                        )
                        }
                          <span style={{ marginRight: "5px" }}>
                            <BubbleNotes
                              pageName={"videosection"}
                              pageSrc={imageFetchFromPodcast(id, resources)}
                              data={data}
                              page={id} // pageID
                              newMaskNote={""}
                              currentUser={currentUser}
                              pageNotes={pageNotes}
                              chapter={id}
                              dataBook={data}
                            />
                          </span>
                          <>
                          {isAdmin ? (
                          <ButtonLink 
                            onClick={e => {
                              e.preventDefault();
                              handleMenuClick(e);
                            }}
                          >
                            {/* <img src={MenuWhiteImg} style={{ height: 20 }} /> */}
                            <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" />
                          </ButtonLink>
                          ) : (
                          <Dropdown overlayClassName="menuItemsList" menu={toolbarNav()} placement="bottomRight" trigger={['click']}>
                            <ButtonLink onClick={e => e.preventDefault()}>
                              {/* <img src={MenuWhiteImg} style={{ height: 20 }} /> */}
                              <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" />
                            </ButtonLink>
                          </Dropdown>
                          )}
                          </>
                        </div>



                      </VideoTitleSection>
                      {/* <Typography variant="h5" align="center" style={{ fontSize: '20px !important;', fontFamily: "sans-serif", marginTop: '12px' }}>
                        {timeInt !== 0 && currentUser?.role == 'student' ? timeInt : ""}
                      </Typography> */}
                      
                      <ToolingSubsection className={`${isDrawerOpen ? 'setFullMatchMake' : ''}`}>

                        <div className='extenActivitTool'>
                          <ExtensionActivitiesTooling pageId={id} />
                          {existShowAnswer && (isTeacher||isDistrictAdmin) && (
                            <FormControlLabel
                              className="showAnsSwitch" 
                              classes={{
                                root: classes.root,
                                label: classes.label,
                              }}
                              control={
                                <Switch
                                  classes={{
                                    sizeSmall: classes.sizeSmall,
                                    checked: classes.checkedSwitch,
                                  }}
                                  checked={showAnswerFlag}
                                  onChange={async (e) => {
                                    if (e.target.checked) {
                                      // if (checkPopUpAtOnce()) {
                                      //   return;
                                      // }
                                      updatePopUpAtOnce(true);
                                      setShowAnswerFlag(true);
                                      onAnswerClick()
                                    } else if(!e.target.checked) {
                                      updatePopUpAtOnce(false);
                                      setShowAnswerFlag(false);
                                      revokeAnswerView()
                                    }
                                  }}
                                  name="viewFlag"
                                  color="primary"
                                  size="small"
                                  sx={{
                                    width: 52, // Increased width
                                    //height: 22,
                                    //padding: 0,
                                    '& .MuiSwitch-switchBase': {
                                      padding: 1,
                                      '&.Mui-checked': {
                                        transform: 'translateX(28px)', // Adjust thumb movement
                                      },
                                    },
                                    '& .MuiSwitch-thumb': {
                                      width: 16,
                                      height: 16,
                                      padding: 0,
                                    },
                                    '& .MuiSwitch-track': {
                                      borderRadius: 20,
                                      width: 52,
                                      height: 11,
                                    },
                                  }}
                                />
                              }
                              label="Show Answers"
                            />
                          )} 
                          {hasActivitiesWithStandards && (
                            <ShowStandardButton
                              onClick={async () => {
                                if (activityStandardsView.open) {
                                  updatePopUpAtOnce(false);
                                  revokeActivityStandardsView();
                                } else {
                                  if (openPopUpAtOnce) {
                                    checkPopUpAtOnce();
                                    return;
                                  }
                                  updatePopUpAtOnce(true);
                                  const units = data?.structures || [];
                                  const pages = data?.content || [];
                                  invokeActivityStandardsView(allActivitiesForStandards, standards, enabledStateCodes, bookData, units, pages, id);
                                }
                              }}
                            >
                              <ShowStandardButtonInner>
                                Show Standards
                              </ShowStandardButtonInner>
                            </ShowStandardButton>
                          )}
                          {pdf_page && (isTeacher||isDistrictAdmin) && (
                            <FormControlLabel
                              classes={{
                                root: classes.root,
                                label: classes.label,
                              }}
                              control={
                                <Switch
                                  classes={{
                                    sizeSmall: classes.sizeSmall,
                                    checked: classes.checkedSwitch,
                                  }}
                                  checked={pdfView?.open}
                                    onChange={async (e) => {
                                      if (e.target.checked) {
                                        if (checkPopUpAtOnce()) {
                                          return;
                                        }
                                        onPDFClick()
                                      } else if(!e.target.checked) {
                                        updatePopUpAtOnce(false);
                                        revokePDFView()
                                      }
                                    }}
                                  name="pdfFlag"
                                  color="primary"
                                  size="small"
                                />
                              }
                              label="View as PDF"
                            />
                          )}
                          {
                            <FormControlLabel
                            classes={{
                              root: classes.root,
                              label: classes.label,
                            }}
                            control={
                              <Switch
                                classes={{
                                  sizeSmall: classes.sizeSmall,
                                  checked: classes.checkedSwitch,
                                }}
                                checked={activeBtnForDescription}
                                  onChange={async (e) => {
                                    if (e.target.checked) {
                                      if (checkPopUpAtOnce()) {
                                        return;
                                      }
                                      if (timmerRunning) {
                                        timmerAlert()
                                      } else {
                                        setActiveBtnForDescription(true)
                                        setActiveBtn(BTN_KEY[3]);
                                      } 
                                    } else if(!e.target.checked) {
                                      updatePopUpAtOnce(false);
                                      if (timmerRunning) {
                                        timmerAlert()
                                      } else {
                                        setActiveBtn(BTN_KEY[2]);
                                        setActiveBtnForDescription(false)
                                      }
                                    }
                                  }}
                                name="pdfFlag"
                                color="primary"
                                size="small"
                              />
                            }
                            label="Description"
                          />
                          }
                        </div>

                        <ActivtyButtonConatiner>
                          {((isTeacher||isDistrictAdmin) || listenActions?.caption) && (
                            <TrackDownloader vttText={vttText}  id={id} title={getBookDisplayName(booksAllList, id, true, videos, resources)} engTrack={vttTextEng} />
                          )}
                        </ActivtyButtonConatiner>
                        <SuperLessonDiffList 
                                        shareWithMe={shareWithMe}
                                        setShareWithMe={setShareWithMe}
                                        shareByMe={shareByMe}
                                        setShareByMe={setShareByMe} 
                                        chapter={id}
                                        from={'podcast'}
                                    />
                        <ToolsWrapper className={`${isDrawerOpen ? 'setFullMatchMake' : ''}`}>
                          {loadingContent ? <Loading /> :
                            <PodcastTooling
                              isDrawerOpen={isDrawerOpen}
                              data={data}
                              id={id}
                              quiz={search.quiz}
                              activity={search.activity}
                              section={BTN_KEY.findIndex((k) => k == activeBtn)}
                              tipsBook={tipsBook}
                              quizzes={quizzes}
                              setShowAnswerFlag={setShowAnswerFlag}
                              showAnswerFlag={showAnswerFlag}
                              classUsers={classUsers}
                              classQuizzes={classQuizzes}
                              submissions={submissions}
                              studentViewFlag={studentViewFlag}
                              setStudentViewFlag={setStudentViewFlag}
                              loadingContent={loadingContent}
                              search={search}
                              setSubmitRef={setSubmitRef}
                              timeInt={timeInt}
                              timmer={timeIntRef.current}
                              videoInfo={find(get(find(resources, ['key', search.link]), "videos"), ["id", search.id])}
                              onFinish={onFinish}
                              onPageChage={re => clearPreviewRef.current = re}
                              track={vttText}
                              engTrack={vttTextEng}
                              listenActions={listenActions}
                              title={getBookDisplayName(booksAllList, id, true, videos, resources)}
                              onClose={() => {
                                setActiveBtn(BTN_KEY[2]);
                              }}
                              handleOpenStoryWithAi={handleOpenStoryWithAi}
                              hasStoryWithAi={hasStoryWithAi}
                              onGenerateClick={onGenerateClick}
                              handlerOpenPresentation={handlerOpen}
                              has_all_page={has_all_page}
                            />}
                        </ToolsWrapper>
                        
                      </ToolingSubsection>
                    </ToolingContainer>
                  </Col>
                </Row>
              </>
            )}
          </ImageContainer>
        </Container>
      </Wrapper>
    </>
    </SentryWrap>
  );
};



export default PodcastLayout;